import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'

import Icon from './common-parts/Icon'

export default function ArrowCircleRightIcon({ ...props }) {
  return (
      <Icon
        color="grey"
        size="lg"
        {...props}
        icon={faArrowCircleRight}
      />
  );
}
